var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9524 29.4502L13 29.4502C11.8954 29.4502 11 28.5548 11 27.4502V14.9502C11 13.8456 11.8954 12.9502 13 12.9502H31C32.1046 12.9502 33 13.8456 33 14.9502V27.4502C33 28.5548 32.1046 29.4502 31 29.4502H30.25",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 19H28.05",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23.9502H20.9",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.85,
    cy: 27.8002,
    r: 3.05,
    stroke: "#172664",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 31.5615L21.1989 35.0915L22.5501 34.9496L23.4489 36.0499L24.942 32.5202C24.1037 32.3953 23.3347 32.0567 22.692 31.5615Z",
    fill: "#172664"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6499 31.5615L30.1431 35.0915L28.7918 34.9496L27.893 36.0499L26.3999 32.5202C27.2383 32.3953 28.0072 32.0567 28.6499 31.5615Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLicense);
export default __webpack_public_path__ + "static/media/btn_license.e974a7335d7e1b6a6b5a9911c04438a2.svg";
export { ForwardRef as ReactComponent };